export const AEM_PLUGIN_ANNOTATION = 'mercedes-benz.io/aem-plugin';
